import { ApiError } from "@vana/core";

export class SearchCustomersError extends ApiError {}
export class GetCaseError extends ApiError {}
export class RevealNationalIdError extends ApiError {}
export class RecordAccessError extends ApiError {}
export class ExportCaseError extends ApiError {}
export class ReplaceCaptureError extends ApiError {}
export class RegisterInternalDeliveryError extends ApiError {}
export class UpdateAddressError extends ApiError {}
export class AddAddressError extends ApiError {}
export class ListGeoCatalogError extends ApiError {}
export class RecordCustodyError extends ApiError {}
